export enum ICDNCommand {
  LOCK, // no data
  UNLOCK, // no data
  RESET, // no data
  RESET_AND_INIT, // data optional ATDLInterfaceControlModel
  LOAD, // data: {value: any, propagate: boolean}
  VALIDATE, // no data
  FOCUS_INPUT, // no data
  ////
  UPDATE_VALIDATION,
  UPDATE_ENTRY_TYPE, // data: OENEntryType
  UPDATE_LABEL, // data: string
  UPDATE_EXTERNAL_STATE, // data: ICNInputControlState
  UPDATE_AUX_MODEL, // data: ICDNAuxModel
  UPDATE_CONSTRAINT, // data: {name: string, value: any}
  INVALID_INPUT, // data: ICDTransportModel {icdId, null, errorMsg}
  UPDATE_PART_FILL_STATE,
  /////
  ENABLE, // no data
  DISABLE, // no data
  ///
  INITIALIZING_START, // no data
  INITIALIZING_END, // no data
  LOADING_START, // no data
  LOADING_END, // no data
  PUSH_VALUE, // no data
  // DEV TEST
  ATDL_CONTROL_VALIDATION,
  SCROLL_IN_VIEW,
}
